export default function NumberChart({ data, chartOptions }) {
  const { numberFunction, format = 'number', comparePrevious } = chartOptions
  const hasComparison = comparePrevious && data.some(r => r.comparisonPeriod !== undefined)

  // When comparing periods, split by comparisonPeriod
  let rawNumber
  let previousNumber = null

  if (hasComparison) {
    const currentRow = data.find(r => r.comparisonPeriod === 0)
    const previousRow = data.find(r => r.comparisonPeriod === -1)
    const metricKey = Object.keys(data[0]).find(k => k !== 'comparisonPeriod')
    rawNumber = currentRow ? Number(currentRow[metricKey]) : 0
    previousNumber = previousRow ? Number(previousRow[metricKey]) : null
  } else if (numberFunction) {
    rawNumber = numberFunction(data[0])
  } else {
    rawNumber = _.values(data[0])[0]
  }

  let number
  if (format === 'percentage') {
    number = (rawNumber * 100).toFixed(1) + '%'
  } else if (format === 'currency') {
    number = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rawNumber)
  } else {
    number = Number(rawNumber).toLocaleString()
  }

  // Compute trend
  let trend = null
  if (hasComparison && previousNumber !== null) {
    if (previousNumber !== 0) {
      const change = rawNumber - previousNumber
      const percent = ((change / previousNumber) * 100).toFixed(1)
      trend = { direction: change > 0 ? 'up' : change < 0 ? 'down' : 'flat', percent }
    } else if (rawNumber > 0) {
      trend = { direction: 'up', percent: null }
    } else {
      trend = { direction: 'flat', percent: '0.0' }
    }
  }

  const arrow = trend?.direction === 'up' ? '\u2191' : trend?.direction === 'down' ? '\u2193' : '\u2192'
  const trendClass = trend ? `number-chart__trend--${trend.direction}` : ''

  return <div className='number-chart'>
    <div className="value">
      { number }
    </div>
    <div className='description'>{chartOptions.title}</div>
    {trend && (
      <div className={`number-chart__trend ${trendClass}`}>
        <span className="number-chart__arrow">{arrow}</span>
        {trend.percent !== null && (
          <span className="number-chart__percent">{Math.abs(trend.percent)}%</span>
        )}
        <span className="number-chart__period">vs previous period</span>
      </div>
    )}
  </div>
}
